import { Box } from "@mui/material";
import { type Theme, useTheme } from "@mui/material/styles";
import { CHARGE_STATUS_LABELS } from "@/pages/sy/constants/chargeStatus";
import {
  CHARGE_STATUS_CODES,
  type ChargeStatusCode,
} from "@/pages/sy/models/Charge";

type ChargeStatus = {
  name: string;
  getColor: (theme: Theme) => string;
  letter: string;
};

const chargeStatuses: Record<ChargeStatusCode, ChargeStatus> = {
  [CHARGE_STATUS_CODES.SCHEDULED]: {
    name: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.SCHEDULED],
    getColor: (theme) => theme.palette.info.main,
    letter: CHARGE_STATUS_CODES.SCHEDULED,
  },
  [CHARGE_STATUS_CODES.OPEN]: {
    name: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.OPEN],
    getColor: (theme) => theme.palette.charges.status.active,
    letter: CHARGE_STATUS_CODES.OPEN,
  },
  [CHARGE_STATUS_CODES.CLOSED]: {
    name: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.CLOSED],
    getColor: (theme) => theme.palette.charges.chargeTypes.closed,
    letter: CHARGE_STATUS_CODES.CLOSED,
  },
  [CHARGE_STATUS_CODES.CHARGED_INTO_EAF]: {
    name: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.CHARGED_INTO_EAF],
    getColor: (theme) => theme.palette.charges.status.inactive,
    letter: CHARGE_STATUS_CODES.CHARGED_INTO_EAF,
  },
};

type ChargeStatusTagProps = {
  code: string;
};

export const ChargeStatusTag = ({ code }: ChargeStatusTagProps) => {
  const theme = useTheme();

  const status = chargeStatuses[code as ChargeStatusCode] || {
    name: "Unknown",
    getColor: (theme: Theme) => theme.palette.grey[600],
    letter: "?",
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box
        title={status.name}
        sx={{
          width: "28px",
          height: "28px",
          borderRadius: "4px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontWeight: "bold",
          marginRight: "8px",
          fontSize: "14px",
          backgroundColor: status.getColor(theme),
        }}
      >
        {status.letter}
      </Box>
    </Box>
  );
};
